import {apiClient} from "../../providers/apiClient";
import Utilities from "../../utils/Utilities";

const getFormData = (data) => {
    let formData = new FormData();

    for (let key in data) {
        formData.append(key, data[key] ?? '');
    }

    return formData;
}



const getList = (filters) => {
    return apiClient.get('/api/Company/list', {
        params: filters,
    });
}

const getById = (companyId) => {
    return apiClient.get(`/api/admin/companies/${companyId}`);
}


const update = (companyId, data) => {
    const form = getFormData(data);
    return  apiClient.put(`/api/Company/${companyId}`, form);
}

const downloadCsv = async (filters) => {
    try {
        const response = await apiClient.get('/api/Company/csv', {
            params: filters,
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        const fileName = `companies-report_${Utilities.formatDateForFilename()}.csv`;

        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Błąd przy pobieraniu pliku CSV:', error);
    }
}

export default {
    getById,
    update,
    downloadCsv,
    getList,
}